<template>
	<div
		class="relative h-6 w-9 rounded-full transition-colors"
		:class="{
			'bg-label-tertiary': !model,
			'bg-yellow': model
		}"
	>
		<div
			class="bg-fill-tertiary absolute top-0.5 h-5 w-5 rounded-full transition-all"
			:class="{
				'left-0.5': !model,
				'left-3.5': model
			}"
		></div>
	</div>
</template>
<script setup lang="ts">
const model = defineModel<boolean>()
</script>
